import { splitHashtags } from './hashtags'

/**
 * A transaction description with its #hashtags picked out and tappable.
 *
 * Managers file transactions by writing tags into the description — «قبض برق
 * #هزینه_جاری» — and then want the rest of that file. Tapping a tag hands it to
 * `onHashtagClick`, which the transaction list turns into the same `q=` search
 * the member-search box already uses; the server matches it against the
 * description column.
 *
 * Without `onHashtagClick` the tags are still coloured but inert, so this can be
 * used on read-only surfaces without pretending to be interactive.
 */
export default function HashtagText({
    text,
    onHashtagClick,
    className,
}: {
    text: string
    onHashtagClick?: (hashtag: string) => void
    className?: string
}) {
    const segments = splitHashtags(text)

    return (
        <span className={className}>
            {segments.map((segment, index) =>
                segment.hashtag === null ? (
                    // eslint-disable-next-line react/no-array-index-key
                    <span key={index}>{segment.text}</span>
                ) : onHashtagClick ? (
                    <button
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        type="button"
                        // `align-baseline` and no padding: the tag sits inside a
                        // sentence, so it has to keep the line's rhythm rather
                        // than render as a button-shaped box mid-paragraph.
                        className="align-baseline text-blue-1 font-bold"
                        onClick={() => onHashtagClick(segment.hashtag as string)}
                    >
                        {segment.text}
                    </button>
                ) : (
                    // eslint-disable-next-line react/no-array-index-key
                    <span key={index} className="text-blue-1 font-bold">
                        {segment.text}
                    </span>
                )
            )}
        </span>
    )
}
